import React, { useEffect } from 'react';
import { mobileSendMessageToApp } from '../../../services/window-utils';

const MobileThanks = () => {
  useEffect(() => {
    mobileSendMessageToApp.successPage();
  }, []);

  return <div data-hook="mobileThanks" />;
};

export default MobileThanks;
